import React from 'react';
import { useIntl } from 'react-intl';
import { Field } from 'react-final-form';

import Textarea, { TextareaProps } from '../Textarea';

type FormTextareaProps = Omit<TextareaProps, 'value' | 'onChange'> & {
  name: string
  format?: (value: string, name: string) => string
  parse?: (value: string, name: string) => string
  validate?: (value: string, allValues: unknown) => string | undefined
};

const FormTextarea: React.FC<FormTextareaProps> = ({
  autoFocus,
  label,
  name,
  rows,
  disabled,
  required,
  format,
  parse,
  validate,
  className,
  description,
  placeholder,
  'data-testid': dataTestId,
  inputClassName
}) => {
  const intl = useIntl();
  return (
    <Field name={name} subscription={{ value: true, error: true }} format={format} parse={parse} validate={validate}>
      {({ input, meta }) => (
        <Textarea
          rows={rows}
          label={label}
          value={input.value}
          disabled={disabled}
          required={required}
          autoFocus={autoFocus}
          className={className}
          onChange={input.onChange}
          placeholder={placeholder}
          error={meta.error && intl.formatMessage({ id: meta.error, defaultMessage: meta.error })}
          data-testid={dataTestId}
          description={description}
          inputClassName={inputClassName}
        />
      )}
    </Field>
  );
};

export default FormTextarea;
